/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ReplaceIdentityProviderConnectionClientSecretRequestBody,
  ReplaceIdentityProviderConnectionClientSecretRequestBody$Outbound,
  ReplaceIdentityProviderConnectionClientSecretRequestBody$outboundSchema,
} from "../components/replaceidentityproviderconnectionclientsecretrequestbody.js";

export type ReplaceIdentityProviderConnectionClientSecretSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ReplaceIdentityProviderConnectionClientSecretRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  replaceIdentityProviderConnectionClientSecretRequestBody:
    ReplaceIdentityProviderConnectionClientSecretRequestBody;
};

/** @internal */
export type ReplaceIdentityProviderConnectionClientSecretSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ReplaceIdentityProviderConnectionClientSecretSecurity$outboundSchema:
  z.ZodMiniType<
    ReplaceIdentityProviderConnectionClientSecretSecurity$Outbound,
    ReplaceIdentityProviderConnectionClientSecretSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function replaceIdentityProviderConnectionClientSecretSecurityToJSON(
  replaceIdentityProviderConnectionClientSecretSecurity:
    ReplaceIdentityProviderConnectionClientSecretSecurity,
): string {
  return JSON.stringify(
    ReplaceIdentityProviderConnectionClientSecretSecurity$outboundSchema.parse(
      replaceIdentityProviderConnectionClientSecretSecurity,
    ),
  );
}

/** @internal */
export type ReplaceIdentityProviderConnectionClientSecretRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  ReplaceIdentityProviderConnectionClientSecretRequestBody:
    ReplaceIdentityProviderConnectionClientSecretRequestBody$Outbound;
};

/** @internal */
export const ReplaceIdentityProviderConnectionClientSecretRequest$outboundSchema:
  z.ZodMiniType<
    ReplaceIdentityProviderConnectionClientSecretRequest$Outbound,
    ReplaceIdentityProviderConnectionClientSecretRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      replaceIdentityProviderConnectionClientSecretRequestBody:
        ReplaceIdentityProviderConnectionClientSecretRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        replaceIdentityProviderConnectionClientSecretRequestBody:
          "ReplaceIdentityProviderConnectionClientSecretRequestBody",
      });
    }),
  );

export function replaceIdentityProviderConnectionClientSecretRequestToJSON(
  replaceIdentityProviderConnectionClientSecretRequest:
    ReplaceIdentityProviderConnectionClientSecretRequest,
): string {
  return JSON.stringify(
    ReplaceIdentityProviderConnectionClientSecretRequest$outboundSchema.parse(
      replaceIdentityProviderConnectionClientSecretRequest,
    ),
  );
}
